export default __webpack_public_path__ + "static/media/cx_cover_lnn1.35180223.jpg";